import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Skeleton,
  Stack,
  styled,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import React, { useEffect, useState } from "react";
import useFetchDataPribadi from "../../../api/effects/queries/DataPribadi/useFetchDataPribadi";
import InputDate from "../../../components/InputDate";
import InputSelect from "../../../components/InputSelect";
import InputTextField from "../../../components/InputTextField";
import { useQueryClient } from "react-query";

import {
  convertDate,
  convertDateTime,
  toIsoStringDate,
} from "../../../utils/dateConvert";
import separateNumber, { formatNumber } from "../../../utils/formatPrice";
import { InputFileModal } from "../../../components/InputFileModal";
import { useAddDataPribadi } from "../../../api/effects/mutations/DataPribadi/addDataPribadi";
import { useEditDataPribadi } from "../../../api/effects/mutations/DataPribadi/EditDataPribadi";
import { WarningModal } from "../../../components/WarningModal";
import { useAddKTP } from "../../../api/effects/mutations/DataPribadi/addKTP";
import { useAddNPWP } from "../../../api/effects/mutations/DataPribadi/addNPWP";
import { useAddFotoProfile } from "../../../api/effects/mutations/DataPribadi/addFotoProfile";
import { useAddCV } from "../../../api/effects/mutations/DataPribadi/addCV";
import { useAddIjazah } from "../../../api/effects/mutations/DataPribadi/addIjazah";
import LoadingScreen from "../../../components/LoadingScreen";
import { GridSkeleton, SkeletonTable, SkeletonText } from "../ProfileTabPage";
import { DataPribadiResponse } from "../../../models/DataPribadi";
import { useAddTranskripNilai } from "../../../api/effects/mutations/DataPribadi/addTranskripNilai";
import { dataPribadiKey } from "../../../api/effects/queries/DataPribadi/useFetchDataPribadi";
import { checkProfileKey } from "../../../api/effects/queries/User/useFetchCheckProfile";

const SquareGrid = styled(Grid)(({ theme }) => ({
  backgroundColor: "#FFF",
  boxShadow: "1px 1px 10px #888888",
  height: "auto",
  width: "90%",
  maxWidth: "600px",
  borderRadius: "10px",
  margin: "1%",
  [theme.breakpoints.down("md")]: {
    margin: "10px",
  },
}));

const FullGrid = styled(Grid)(({ theme }) => ({
  height: "auto",
  paddingRight: "10%",
  width: "90%",
  maxWidth: "600px",
  margin: "1%",
  [theme.breakpoints.down("md")]: {
    margin: "10px",
  },
}));

const FlexSquareGrid = styled(Grid)(({ theme }) => ({
  backgroundColor: "#FFF",
  height: "100%",
  width: "90%",
  maxWidth: "600px",
  boxShadow: "1px 1px 10px #888888",
  borderRadius: "10px",
  margin: "1%",
  [theme.breakpoints.down("md")]: {
    margin: "10px",
  },
}));

const ButtonFull = styled(Button)(({ theme }) => ({
  padding: "10px",
  width: "80%",
  justifyContent: "flex-start",
  margin: "10px",
}));

const TitleGrid = styled(Grid)(({ theme }) => ({
  paddingLeft: "3%",
  paddingBottom: "1%",
  paddingTop: "1%",
}));

export default function DataPribadiPage() {
  const queryClient = useQueryClient();
  const { data: DataPribadi } = useFetchDataPribadi();
  const [loading, setLoading] = useState(true);
  const [dataLoading, setDataLoading] = useState(true);
  const [isUploading, setIsUploading] = useState(false);

  const [dataPribadiID, setDataPribadiID] = useState(-1);
  const [namaDepan, setNamaDepan] = useState("");
  const [namaBelakang, setNamaBelakang] = useState("");
  const [jenisKelamin, setJenisKelamin] = useState("");
  const [tempatLahir, setTempatLahir] = useState("");
  const [tanggalLahir, setTanggalLahir] = useState(toIsoStringDate(Date.now()));
  const [alamatDalamKota, setAlamatDalamKota] = useState("");
  const [alamatLuarKota, setAlamatLuarKota] = useState("");
  const [kepemilikanAlamatLuarKota, setKepemilikanAlamatLuarKota] =
    useState("");
  const [nomorHandphone, setNomorHandphone] = useState("");
  const [tinggiBadan, setTinggiBadan] = useState("");
  const [beratBadan, setBeratBadan] = useState("");
  const [golonganDarah, setGolonganDarah] = useState("");
  const [agama, setAgama] = useState("");
  const [kebangsaan, setKebangsaan] = useState("");
  // const [KTP, setKTP] = useState("");
  // const [simA, setSimA] = useState<string>("");
  // const [tanggalSimA, setTanggalSimA] = useState<string>(
  //   toIsoStringDate(Date.now())
  // );
  // const [simC, setSimC] = useState<string>("");
  // const [tanggalSimC, setTanggalSimC] = useState<string>(
  //   toIsoStringDate(Date.now())
  // );
  const [kendaraan, setKendaraan] = useState<string>("");
  const [jenisKendaraan, setJenisKendaraan] = useState<string>("");
  const [kepemilikanKendaraan, setKepemilikanKendaraan] = useState<string>("");
  const [facebook, setFacebook] = useState<string>("");
  const [instagram, setInstagram] = useState<string>("");
  const [twitter, setTwitter] = useState<string>("");
  const [youtube, setYoutube] = useState<string>("");
  const [linkedin, setLinkedin] = useState<string>("");
  const [CVFile, setCVFile] = useState<number>(0);
  // const [KTPFile, setKTPFile] = useState<number>(0);
  // const [NPWPFile, setNPWPFile] = useState<number>(0);
  const [IjazahFile, setIjazahFile] = useState<number>(0);
  const [TranskripNilaiFile, setTranskripNilaiFile] = useState<number>(0);
  const [FotoFile, setFotoFile] = useState<number>(0);
  const [cvFileName, setCvFileName] = useState("");
  const [ijazahFileName, setIjazahFileName] = useState("");
  const [transkripNilaiFileName, setTranskripNilaiFileName] = useState("");
  const [fotoFileName, setFotoFileName] = useState("");
  const [noFacebook, setnoFacebook] = useState(false);

  const handleNoFacebook = () => {
    if (!noFacebook) {
      setFacebook("Tidak Memiliki Akun Facebook");
    } else {
      setFacebook("");
    }
    setnoFacebook(!noFacebook);
  };

  const [noInstagram, setnoInstagram] = useState(false);

  const handleNoInstagram = () => {
    if (!noInstagram) {
      setInstagram("Tidak Memiliki Akun Instagram");
    } else {
      setInstagram("");
    }
    setnoInstagram(!noInstagram);
  };

  const [noYoutube, setnoYoutube] = useState(false);

  const handleNoYoutube = () => {
    if (!noYoutube) {
      setYoutube("Tidak Memiliki Akun Youtube");
    } else {
      setYoutube("");
    }
    setnoYoutube(!noYoutube);
  };

  const [noTwitter, setnoTwitter] = useState(false);

  const handleNoTwitter = () => {
    if (!noTwitter) {
      setTwitter("Tidak Memiliki Akun Twitter");
    } else {
      setTwitter("");
    }
    setnoTwitter(!noTwitter);
  };

  const [noLinkedin, setnoLinkedin] = useState(false);

  const handleNoLinkedin = () => {
    if (!noLinkedin) {
      setLinkedin("Tidak Memiliki Akun Linkedin");
    } else {
      setLinkedin("");
    }
    setnoLinkedin(!noLinkedin);
  };

  const resetState = async () => {
    setDataPribadiID(-1);
    setJenisKelamin("");
    setNamaDepan("");
    setNamaBelakang("");
    setTempatLahir("");
    setTanggalLahir(toIsoStringDate(Date.now()));
    setAlamatDalamKota("");
    setAlamatLuarKota("");
    setKepemilikanAlamatLuarKota("");
    setNomorHandphone("");
    setTinggiBadan("");
    setBeratBadan("");
    setGolonganDarah("");
    setAgama("");
    setKebangsaan("");
    // setKTP("");
    // setSimA("");
    // setTanggalSimA(toIsoStringDate(Date.now()));
    // setSimC("");
    // setTanggalSimC(toIsoStringDate(Date.now()));
    setKendaraan("");
    setJenisKendaraan("");
    setKepemilikanKendaraan("");
    setFacebook("");
    setInstagram("");
    setTwitter("");
    setYoutube("");
    setLinkedin("");
    // setKTPFile(0);
    // setNPWPFile(0);
    setIjazahFile(0);
    setFotoFile(0);
    setCVFile(0);
  };

  const setAllState = async (data: DataPribadiResponse) => {
    setDataPribadiID(data.DATA_PRIBADI_ID);
    setJenisKelamin(data.JENIS_KELAMIN || "");
    setNamaDepan(data.NAMA_DEPAN || "");
    setNamaBelakang(data.NAMA_BELAKANG || "");
    setTempatLahir(data.TEMPAT_LAHIR || "");
    if (data.TANGGAL_LAHIR !== null) {
      setTanggalLahir(data.TANGGAL_LAHIR);
    }
    setAlamatDalamKota(data.ALAMAT_DALAM_KOTA || "");
    setAlamatLuarKota(data.ALAMAT_LUAR_KOTA || "");
    setKepemilikanAlamatLuarKota(data.KEPEMILIKAN_ALAMAT_LUAR_KOTA || "");
    setNomorHandphone(data.NOMOR_HANDPHONE || "");
    setTinggiBadan(data.TINGGI_BADAN || "");
    setBeratBadan(data.BERAT_BADAN || "");
    setGolonganDarah(data.GOLONGAN_DARAH || "");
    setAgama(data.AGAMA || "");
    setKebangsaan(data.KEBANGSAAN || "");
    // setKTP(data.KTP);
    // setSimA(data.SIM_A);
    // if (data.TANGGAL_SIM_A !== null) {
    //   setTanggalSimA(data.TANGGAL_SIM_A);
    // }
    // setSimC(data.SIM_C);
    // if (data.TANGGAL_SIM_C !== null) {
    //   setTanggalSimC(data.TANGGAL_SIM_C);
    // }
    setKendaraan(data.KENDARAAN || "");
    setJenisKendaraan(data.JENIS_KENDARAAN || "");
    setKepemilikanKendaraan(data.KEPEMILIKAN_KENDARAAN || "");
    if (data.FACEBOOK === "Tidak Memiliki Akun Facebook") {
      setnoFacebook(true);
    }
    setFacebook(data.FACEBOOK || "");
    if (data.INSTAGRAM === "Tidak Memiliki Akun Instagram") {
      setnoInstagram(true);
    }
    setInstagram(data.INSTAGRAM || "");
    if (data.TWITTER === "Tidak Memiliki Akun Twitter") {
      setnoTwitter(true);
    }
    setTwitter(data.TWITTER || "");
    if (data.YOUTUBE === "Tidak Memiliki Akun Youtube") {
      setnoYoutube(true);
    }
    setYoutube(data.YOUTUBE || "");
    if (data.LINKEDIN === "Tidak Memiliki Akun Linkedin") {
      setnoLinkedin(true);
    }
    setLinkedin(data.LINKEDIN || "");
    // setKTPFile(data.KTP_FILE);
    // setNPWPFile(data.NPWP_FILE);
    setIjazahFile(data.IJAZAH_FILE);
    setTranskripNilaiFile(data.TRANSKRIP_NILAI_FILE);
    setFotoFile(data.FOTO_FILE);
    setCVFile(data.CV_FILE);
  };
  useEffect(() => {
    resetState();
  }, []);

  useEffect(() => {
    resetState().then(() => {
      if (DataPribadi !== undefined && DataPribadi.DATA_PRIBADI_ID !== null) {
        setAllState(DataPribadi).then(() => setDataLoading(false));
      } else {
        setDataLoading(false);
      }
    });
  }, [DataPribadi]);

  const [warningModalState, setWarningModalState] = useState(false);
  const [warningModalText, setWarningModalText] = useState("");

  const validatePhoneNumber = (phoneNumber: string): string | boolean => {
    if (!phoneNumber.startsWith('08')) {
      return 'Nomer telepon harus dimulai dengan angka "08".';
    }
    if (phoneNumber.length < 10) {
      return 'Nomer telepon terlalu pendek. Panjang minimal 10 digit.';
    }
    if (phoneNumber.length > 15) {
      return 'Nomer telepon terlalu panjang. Panjang maksimal 15 digit.';
    }
    const regex = /^08\d{8,14}$/;
    if (!regex.test(phoneNumber)) {
      return 'Nomer telepon hanya menerima angka.';
    }
    return true;
  };

  const { mutateAsync: EditDataPribadi } = useEditDataPribadi({
    onSuccess() {
      queryClient.invalidateQueries(dataPribadiKey);
      queryClient.invalidateQueries(checkProfileKey);
      setWarningModalText("Data Pribadi Saved");
      setWarningModalState(true);
      console.log("Success");
    },
    onError() {
      setWarningModalText("Error Saving Data Pribadi");
      setWarningModalState(true);
      console.log("Error");
    },
  });
  const { mutateAsync: AddDataPribadi } = useAddDataPribadi({
    onSuccess() {
      queryClient.invalidateQueries(dataPribadiKey);
      queryClient.invalidateQueries(checkProfileKey);
      setWarningModalText("Data Pribadi Saved");
      setWarningModalState(true);
      console.log("Success");
    },
    onError() {
      setWarningModalText("Error Saving Data Pribadi");
      setWarningModalState(true);
      console.log("Error");
    },
  });

  const handleFormValidation = () => {
    if (jenisKelamin === "" || jenisKelamin === null) {
      setWarningModalText("Jenis Kelamin Wajib Diisi.");
      setWarningModalState(true);
      return false;
    }
    if (namaDepan === "" || namaDepan === null) {
      setWarningModalText("Nama Depan Wajib Diisi.");
      setWarningModalState(true);
      return false;
    }
    if (namaDepan.length < 2) {
      setWarningModalText("Nama Depan harus lebih dari 2 karakter.");
      setWarningModalState(true);
      return false;
    }

    if (!/^[A-Za-z\s]+$/.test(namaDepan)) {
      setWarningModalText("Nama Depan hanya boleh huruf atau spasi");
      setWarningModalState(true);
      return false;
    }


    if (tempatLahir === "" || tempatLahir === null) {
      setWarningModalText("Tempat Lahir Wajib Diisi.");
      setWarningModalState(true);
      return false;
    }
    if (!/^[A-Za-z\s]+$/.test(tempatLahir)) {
      setWarningModalText("Tempat lahir tidak boleh mengandung angka atau simbol.");
      setWarningModalState(true);
      return false;
    }
    if (convertDate(tanggalLahir) === convertDate(Date.now()) || tanggalLahir === null) {
      setWarningModalText("Tanggal Lahir Wajib Diisi.");
      setWarningModalState(true);
      return false;
    }

    const lahir = new Date(tanggalLahir);
    const now = new Date();
    const umur = now.getFullYear() - lahir.getFullYear();
    if (isNaN(lahir.getTime())) {
      setWarningModalText("Format Tanggal Lahir tidak valid.");
      setWarningModalState(true);
      return false;
    }
    if (umur <= 0) {
      setWarningModalText("Tanggal Lahir tidak valid");
      setWarningModalState(true);
      return false;
    }
    if (umur < 17 && umur > 0) {
      setWarningModalText("Umur minimal 17 tahun sesuai KTP.");
      setWarningModalState(true);
      return false;
    }
    if (umur > 120) {
      setWarningModalText("Umur maksimal 120 tahun.");
      setWarningModalState(true);
      return false;
    }

    if (alamatDalamKota === "" || alamatDalamKota === null) {
      setWarningModalText("Alamat Sesuai KTP Wajib Diisi.");
      setWarningModalState(true);
      return false;
    }
    if (alamatDalamKota.length < 10) {
      setWarningModalText("Alamat Sesuai KTP minimal 10 karakter.");
      setWarningModalState(true);
      return false;
    }
    if (alamatLuarKota === "" || alamatLuarKota === null) {
      setWarningModalText("Alamat Domisili Wajib Diisi.");
      setWarningModalState(true);
      return false;
    }
    if (alamatLuarKota.length < 10) {
      setWarningModalText("Alamat Domisili minimal 10 karakter.");
      setWarningModalState(true);
      return false;
    }

    if (kepemilikanAlamatLuarKota === "" || kepemilikanAlamatLuarKota === null) {
      setWarningModalText("Kepemilikan Domisili Wajib Diisi.");
      setWarningModalState(true);
      return false;
    }
    if (nomorHandphone === "" || nomorHandphone === null) {
      setWarningModalText("Nomor Handphone Wajib Diisi.");
      setWarningModalState(true);
      return false;
    } else {
      // Phone Number Validation
      var isValid = validatePhoneNumber(nomorHandphone);
      // If returns string, show missing validation alert
      if (typeof isValid === "string") {
        setWarningModalText(isValid);
        setWarningModalState(true);
        return false;
      }
    }
    if (tinggiBadan === "" || tinggiBadan == null || tinggiBadan === "0") {
      setWarningModalText("Tinggi Badan Wajib Diisi.");
      setWarningModalState(true);
      return false;
    }
    if (parseInt(tinggiBadan, 10) < 100) {
      setWarningModalText("Tinggi Badan tidak valid. Harap diisi dengan benar dalam cm.");
      setWarningModalState(true);
      return false;
    }
    if (beratBadan === "" || beratBadan == null || beratBadan === "0") {
      setWarningModalText("Berat Badan Wajib Diisi.");
      setWarningModalState(true);
      return false;
    }
    if (parseInt(beratBadan, 10) < 30) {
      setWarningModalText("Berat Badan tidak valid. Harap diisi dengan benar dalam kg.");
      setWarningModalState(true);
      return false;
    }
    if (golonganDarah === "" || golonganDarah == null) {
      setWarningModalText("Golongan Darah Wajib Diisi.");
      setWarningModalState(true);
      return false;
    }
    if (agama === "" || agama === null) {
      setWarningModalText("Agama/Kepercayaan Wajib Diisi.");
      setWarningModalState(true);
      return false;
    }
    if (kebangsaan === "" || kebangsaan === null) {
      setWarningModalText("Kebangsaan Wajib Diisi.");
      setWarningModalState(true);
      return false;
    }
    if (!/^[A-Za-z\s]+$/.test(kebangsaan)) {
      setWarningModalText("Kebangsaan tidak boleh mengandung angka atau simbol.");
      setWarningModalState(true);
      return false;
    }

    if ((facebook === "" || facebook === null) && noFacebook == false) {
      setWarningModalText("Facebook Wajib Diisi atau Dipilih.");
      setWarningModalState(true);
      return false;
    }
    if (((instagram === "" || instagram === null) || instagram === null) && noInstagram == false) {
      setWarningModalText("Instagram Wajib Diisi atau Dipilih.");
      setWarningModalState(true);
      return false;
    }
    if (((youtube === "" || youtube === null) || youtube === null) && noYoutube == false) {
      setWarningModalText("Youtube Wajib Diisi atau Dipilih.");
      setWarningModalState(true);
      return false;
    }
    if ((twitter === "" || twitter == null) && noTwitter == false) {
      setWarningModalText("Twitter Wajib Diisi atau Dipilih.");
      setWarningModalState(true);
      return false;
    }
    if ((linkedin === "" || linkedin === null) && noLinkedin == false) {
      setWarningModalText("LinkedIn Wajib Diisi atau Dipilih.");
      setWarningModalState(true);
      return false;
    }
    return true;
  }

  const handleSave = () => {
    if (!handleFormValidation()) return

    if (dataPribadiID > 0) {
      EditDataPribadi({
        DATA_PRIBADI_ID: dataPribadiID,
        NAMA_DEPAN: namaDepan,
        NAMA_BELAKANG: namaBelakang,
        JENIS_KELAMIN: jenisKelamin,
        TEMPAT_LAHIR: tempatLahir,
        TANGGAL_LAHIR: toIsoStringDate(tanggalLahir),
        ALAMAT_DALAM_KOTA: alamatDalamKota,
        ALAMAT_LUAR_KOTA: alamatLuarKota,
        KEPEMILIKAN_ALAMAT_LUAR_KOTA: kepemilikanAlamatLuarKota,
        NOMOR_HANDPHONE: nomorHandphone,
        TINGGI_BADAN: tinggiBadan,
        BERAT_BADAN: beratBadan,
        GOLONGAN_DARAH: golonganDarah,
        AGAMA: agama,
        KEBANGSAAN: kebangsaan,
        // KTP: KTP,
        // SIM_A: simA === "" ? "" : simA,
        // TANGGAL_SIM_A: simA !== "" ? toIsoStringDate(tanggalSimA) : null,
        // SIM_C: simC === "" ? "" : simC,
        // TANGGAL_SIM_C: simC !== "" ? toIsoStringDate(tanggalSimC) : null,
        KENDARAAN: kendaraan === "" ? "" : kendaraan,
        JENIS_KENDARAAN: jenisKendaraan === "" ? "" : jenisKendaraan,
        KEPEMILIKAN_KENDARAAN:
          kepemilikanKendaraan === "" ? "" : kepemilikanKendaraan,
        FACEBOOK: facebook === "" ? "" : facebook,
        INSTAGRAM: instagram === "" ? "" : instagram,
        TWITTER: twitter === "" ? "" : twitter,
        YOUTUBE: youtube === "" ? "" : youtube,
        LINKEDIN: linkedin === "" ? "" : linkedin,
      });
    } else {
      AddDataPribadi({
        NAMA_DEPAN: namaDepan,
        NAMA_BELAKANG: namaBelakang,
        JENIS_KELAMIN: jenisKelamin,
        TEMPAT_LAHIR: tempatLahir,
        TANGGAL_LAHIR: toIsoStringDate(tanggalLahir),
        ALAMAT_DALAM_KOTA: alamatDalamKota,
        ALAMAT_LUAR_KOTA: alamatLuarKota,
        KEPEMILIKAN_ALAMAT_LUAR_KOTA: kepemilikanAlamatLuarKota,
        NOMOR_HANDPHONE: nomorHandphone,
        TINGGI_BADAN: tinggiBadan,
        BERAT_BADAN: beratBadan,
        GOLONGAN_DARAH: golonganDarah,
        AGAMA: agama,
        KEBANGSAAN: kebangsaan,
        // KTP: KTP,
        // SIM_A: simA === "" ? "" : simA,
        // TANGGAL_SIM_A: simA !== null ? toIsoStringDate(tanggalSimA) : null,
        // SIM_C: simC === "" ? "" : simC,
        // TANGGAL_SIM_C: simC !== null ? toIsoStringDate(tanggalSimC) : null,
        KENDARAAN: kendaraan === "" ? "" : kendaraan,
        JENIS_KENDARAAN: jenisKendaraan === "" ? "" : jenisKendaraan,
        KEPEMILIKAN_KENDARAAN:
          kepemilikanKendaraan === "" ? "" : kepemilikanKendaraan,
        FACEBOOK: facebook === "" ? "" : facebook,
        INSTAGRAM: instagram === "" ? "" : instagram,
        TWITTER: twitter === "" ? "" : twitter,
        YOUTUBE: youtube === "" ? "" : youtube,
        LINKEDIN: linkedin === "" ? "" : linkedin,
      });
    }
  };

  const [fileUploaded, setFileUploaded] = useState(false);
  const [fileType, setFileType] = useState("");
  const [modalText, setModalText] = useState("");
  const [modal, setModal] = useState(false);

  const handleOpenFile = (e: string, uploaded: boolean) => {
    if (e === "KTP") {
      setFileType(".jpg, .jpeg, .png");
    }
    if (e === "NPWP") {
      setFileType(".jpg, .jpeg, .png");
    }
    if (e === "Foto") {
      setFileType(".jpg, .jpeg, .png");
    }
    if (e === "Ijazah") {
      setFileType("application/pdf, .jpg, .jpeg, .png");
    }
    if (e === "CV") {
      setFileType("application/pdf, .jpg, .jpeg, .png");
    }
    if (e === "TranskripNilai") {
      setFileType("application/pdf, .jpg, .jpeg, .png");
    }
    setFileUploaded(uploaded);
    setModalText(e);
    setModal(true);
  };

  const handleCloseFile = () => {
    setModal(false);
  };

  const { mutateAsync: AddKTP } = useAddKTP({
    onSuccess() {
      setWarningModalText("KTP Uploaded");
      setWarningModalState(true);
      handleCloseFile();
      console.log("Success");
    },
    onError() {
      setWarningModalText("Error Uploading KTP");
      setWarningModalState(true);
      console.log("Error");
    },
  });

  const { mutateAsync: AddNPWP } = useAddNPWP({
    onSuccess() {
      setWarningModalText("NPWP Uploaded");
      setWarningModalState(true);
      handleCloseFile();
      console.log("Success");
    },
    onError() {
      setWarningModalText("Error Uploading NPWP");
      setWarningModalState(true);
      console.log("Error");
    },
  });

  const { mutateAsync: AddFoto } = useAddFotoProfile({
    onSuccess() {
      queryClient.refetchQueries(["file-foto-key"]);
      setWarningModalText("Foto Profile Uploaded");
      setWarningModalState(true);
      handleCloseFile();
      console.log("Success");
    },
    onError() {
      setWarningModalText("Error Uploading Foto Profile ");
      setWarningModalState(true);
      console.log("Error");
    },
  });

  const { mutateAsync: AddCV } = useAddCV({
    onSuccess() {
      setWarningModalText("CV Uploaded");
      setWarningModalState(true);
      handleCloseFile();
      console.log("Success");
    },
    onError() {
      setWarningModalText("Error Uploading CV");
      setWarningModalState(true);
      console.log("Error");
    },
  });

  const { mutateAsync: AddIjazah } = useAddIjazah({
    onSuccess() {
      setWarningModalText("Ijazah Uploaded");
      setWarningModalState(true);
      handleCloseFile();
      console.log("Success");
    },
    onError() {
      setWarningModalText("Error Uploading Ijazah");
      setWarningModalState(true);
      console.log("Error");
    },
  });

  const { mutateAsync: AddTranskripNilai } = useAddTranskripNilai({
    onSuccess() {
      setWarningModalText("Transkrip Nilai Uploaded");
      setWarningModalState(true);
      handleCloseFile();
      console.log("Success");
    },
    onError() {
      setWarningModalText("Error Uploading Transkrip Nilai");
      setWarningModalState(true);
      console.log("Error");
    },
  });

  const handleUploadFile = async (file: File | undefined) => {
    if (!file) return;
    const MAX_FILE_SIZE = 5 * 1024 * 1024;
    if (file.size > MAX_FILE_SIZE) {
      setWarningModalText("Ukuran file tidak boleh lebih dari 5 MB.");
      setWarningModalState(true);
      return;
    }
    const allowedTypes = fileType.split(',').map(t => t.trim()); // Ambil dari state 'fileType'
    const fileExtension = "." + file.name.split('.').pop()?.toLowerCase();

    const isValidType = allowedTypes.includes(file.type) || allowedTypes.includes(fileExtension);

    if (!isValidType) {
      setWarningModalText("Tipe file tidak sesuai. Harap unggah file dengan format yang sesuai.");
      setWarningModalState(true);
      return;
    }
    setIsUploading(true);
    try {

      if (modalText === "KTP") {
        await AddKTP(file);
      }
      if (modalText === "NPWP") {
        await AddNPWP(file);
      }
      if (modalText === "Foto") {
        await AddFoto(file);
        setFotoFileName(file.name);
      }
      if (modalText === "CV") {
        await AddCV(file);
        setCvFileName(file.name);
      }
      if (modalText === "Ijazah") {
        await AddIjazah(file);
        setIjazahFileName(file.name);
      }
      if (modalText === "TranskripNilai") {
        await AddTranskripNilai(file);
        setTranskripNilaiFileName(file.name);
      }
    } catch (error) {
      console.error("Upload failed", error);

    } finally {
      setIsUploading(false);
    }
  };

  const theme = useTheme();

  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    setLoading(false);
  }, []);

  if (dataLoading || loading) {
    return (
      <GridSkeleton justifyContent="center" alignItems="center">
        <SkeletonText variant="text" />
        <SkeletonTable variant="rectangular" />
      </GridSkeleton>
    );
  }

  const checkDateIsSmaller = (date: string) => {
    const currDate = new Date(Date.now());
    currDate.setHours(0, 0, 0, 0);
    const theDate = new Date(date);
    theDate.setHours(0, 0, 0, 0);
    if (theDate < currDate) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <>
      <InputFileModal
        open={modal}
        uploaded={fileUploaded}
        handleClose={handleCloseFile}
        handleSave={handleUploadFile}
        inputAccept={fileType}
        text={modalText}
        isLoading={isUploading}
      />
      <WarningModal
        open={warningModalState}
        handleClose={() => {
          setWarningModalState(false);
        }}
        text={warningModalText}
      />
      <Grid
        container
        justifyContent="center"
        alignContent="center"
        direction={isSmall ? "column" : "row"}
      >
        <TitleGrid container item xs={12} justifyContent="flex-start">
          <Typography variant="h5">Data Pribadi</Typography>
        </TitleGrid>
        <SquareGrid container item sm={12} md={8}>
          <InputSelect
            title={"Jenis Kelamin"}
            value={jenisKelamin || ""}
            selection={[
              { value: "Laki-Laki", text: "Laki-Laki" },
              { value: "Perempuan", text: "Perempuan" },
            ]}
            handleEdit={(e) => setJenisKelamin(e.target.value)}
            helperText={jenisKelamin?.length > 0 ? "" : "*Wajib diisi"}
          />
          <InputTextField
            title={"Nama Depan"}
            value={namaDepan || ""}
            handleEdit={(e) => setNamaDepan(e.target.value)}
            helperText={
              namaDepan?.length > 0 ? (
                ""
              ) : (
                <Typography component="span" sx={{ fontSize: "0.75rem" }} color="error">
                  *Wajib diisi
                </Typography>
              )
            }
          />
          <InputTextField
            title={"Nama Belakang"}
            value={namaBelakang || ""}
            handleEdit={(e) => setNamaBelakang(e.target.value)}
          />
          <InputTextField
            title={"Tempat Lahir"}
            value={tempatLahir || ""}
            handleEdit={(e) => setTempatLahir(e.target.value)}
            helperText={
              tempatLahir?.length > 0 ? (
                ""
              ) : (
                <Typography component="span" sx={{ fontSize: "0.75rem" }} color="error">
                  *Wajib diisi
                </Typography>
              )
            }
          />
          <InputDate
            title={"Tanggal Lahir"}
            value={tanggalLahir}
            handleEdit={(e) => setTanggalLahir(e)}
            helperText={checkDateIsSmaller(tanggalLahir) ? "" : "*Wajib diisi"}
          />
          <InputTextField
            title={"Alamat Sesuai KTP"}
            value={alamatDalamKota || ""}
            handleEdit={(e) => setAlamatDalamKota(e.target.value)}
            helperText={
              alamatDalamKota?.length > 0 ? (
                ""
              ) : (
                <Typography component="span" sx={{ fontSize: "0.75rem" }} color="error">
                  *Wajib diisi
                </Typography>
              )
            }
          />
          <InputTextField
            title={"Alamat Domisili Saat Ini"}
            value={alamatLuarKota || ""}
            handleEdit={(e) => setAlamatLuarKota(e.target.value)}
            helperText={
              alamatDalamKota?.length > 0 ? (
                ""
              ) : (
                <Typography component="span" sx={{ fontSize: "0.75rem" }} color="error">
                  *Wajib diisi
                </Typography>
              )
            }
          />
          <InputSelect
            title={"Kepemilikan Domisili Saat Ini"}
            value={kepemilikanAlamatLuarKota || ""}
            selection={[
              { value: "Rumah Sendiri", text: "Rumah Sendiri" },
              { value: "Rumah Orang Tua", text: "Rumah Orang Tua" },
              { value: "Kontrak", text: "Kontrak" },
            ]}
            handleEdit={(e) => setKepemilikanAlamatLuarKota(e.target.value)}
            helperText={
              kepemilikanAlamatLuarKota?.length > 0 ? "" : "*Wajib diisi"
            }
          />
          <InputTextField
            title={"Nomor Handphone"}
            value={nomorHandphone || ""}
            handleEdit={(e) => setNomorHandphone(e.target.value)}
            helperText={
              nomorHandphone?.length > 0 ? (
                ""
              ) : (
                <Typography component="span" sx={{ fontSize: "0.75rem" }} color="error">
                  *Wajib diisi
                </Typography>
              )
            }
          />
          <InputTextField
            title={"Tinggi Badan (CM)"}
            value={tinggiBadan || ""}
            handleEdit={(e) =>
              setTinggiBadan(formatNumber(e.target.value).toString())
            }
            helperText={
              formatNumber(tinggiBadan) > 100 ? (
                ""
              ) : (
                <Typography component="span" sx={{ fontSize: "0.75rem" }} color="error">
                  *Wajib diisi
                </Typography>
              )
            }
          />
          <InputTextField
            title={"Berat Badan (KG)"}
            value={beratBadan || ""}
            handleEdit={(e) =>
              setBeratBadan(formatNumber(e.target.value).toString())
            }
            helperText={
              formatNumber(beratBadan) > 10 ? (
                ""
              ) : (
                <Typography component="span" sx={{ fontSize: "0.75rem" }} color="error">
                  *Wajib diisi
                </Typography>
              )
            }
          />
          <InputSelect
            title={"Golongan Darah"}
            value={golonganDarah || ""}
            selection={[
              { value: "A", text: "A" },
              { value: "B", text: "B" },
              { value: "AB", text: "AB" },
              { value: "O", text: "O" },
            ]}
            handleEdit={(e) => setGolonganDarah(e.target.value)}
            helperText={golonganDarah?.length > 0 ? "" : "*Wajib diisi"}
          />
          <InputSelect
            title={"Agama/Kepercayaan"}
            value={agama || ""}
            selection={[
              { value: "Islam", text: "Islam" },
              { value: "Katolik", text: "Katolik" },
              { value: "Kristen", text: "Kristen" },
              { value: "Budha", text: "Budha" },
              { value: "Hindu", text: "Hindu" },
              { value: "Konghucu", text: "Konghucu" },
              {
                value: "Kepercayaan Kepada Tuhan YME",
                text: "Kepercayaan Kepada Tuhan YME",
              },
            ]}
            handleEdit={(e) => setAgama(e.target.value)}
            helperText={agama?.length > 0 ? "" : "*Wajib diisi"}
          />
          <InputTextField
            title={"Kebangsaan"}
            value={kebangsaan || ""}
            handleEdit={(e) => setKebangsaan(e.target.value)}
            helperText={
              kebangsaan?.length > 0 ? (
                ""
              ) : (
                <Typography component="span" sx={{ fontSize: "0.75rem" }} color="error">
                  *Wajib diisi
                </Typography>
              )
            }
          />
          {/* <InputTextField
            title={"Nomor KTP"}
            value={KTP}
            handleEdit={(e) => setKTP(formatNumber(e.target.value).toString())}
            helperText={
              KTP?.length > 0 ? (
                ""
              ) : (
                <Typography sx={{ fontSize: "0.75rem" }} color="error">
                  *Wajib diisi
                </Typography>
              )
            }
          />
          <InputTextField
            title={"Nomor SIM A"}
            value={simA}
            handleEdit={(e) => setSimA(e.target.value)}
          />
          <InputDate
            title={"Tanggal Berlaku SIM A"}
            value={tanggalSimA}
            handleEdit={(e) => setTanggalSimA(e)}
          />
          <InputTextField
            title={"Nomor SIM C"}
            value={simC}
            handleEdit={(e) => setSimC(e.target.value)}
          />
          <InputDate
            title={"Tanggal Berlaku SIM C"}
            value={tanggalSimC}
            handleEdit={(e) => setTanggalSimC(e)}
          />
          <InputTextField
            title={"Kendaraan"}
            value={kendaraan}
            handleEdit={(e) => setKendaraan(e.target.value)}
          /> */}
          <InputTextField
            title={"Jenis/Merk Kendaraan"}
            value={jenisKendaraan || ""}
            handleEdit={(e) => setJenisKendaraan(e.target.value)}
          />
          <InputTextField
            title={"Kepemilikan Kendaraan"}
            value={kepemilikanKendaraan || ""}
            handleEdit={(e) => setKepemilikanKendaraan(e.target.value)}
          />
          <InputTextField
            title={"Akun Facebook"}
            disabled={noFacebook}
            value={facebook || ""}
            handleEdit={(e) => setFacebook(e.target.value)}
            helperText={
              facebook?.length > 0 ? (
                ""
              ) : (
                <Typography component="span" sx={{ fontSize: "0.75rem" }} color="error">
                  *Wajib diisi Atau Di Pilih
                </Typography>
              )
            }
          />
          <Grid container justifyContent="center">
            <Grid
              container
              justifyContent="flex-start"
              sx={{ paddingLeft: "11%" }}
            >
              <FormControlLabel
                label={
                  <Typography color="black">
                    {" "}
                    Tidak Memiliki Akun Facebook.
                  </Typography>
                }
                control={
                  <Checkbox
                    checked={noFacebook}
                    onChange={handleNoFacebook}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                }
              />
            </Grid>
          </Grid>
          <InputTextField
            title={"Akun Instagram"}
            disabled={noInstagram}
            value={instagram || ""}
            handleEdit={(e) => setInstagram(e.target.value)}
            helperText={
              instagram?.length > 0 ? (
                ""
              ) : (
                <Typography component="span" sx={{ fontSize: "0.75rem" }} color="error">
                  *Wajib diisi Atau Di Pilih
                </Typography>
              )
            }
          />
          <Grid container justifyContent="center">
            <Grid
              container
              justifyContent="flex-start"
              sx={{ paddingLeft: "11%" }}
            >
              <FormControlLabel
                label={
                  <Typography color="black">
                    {" "}
                    Tidak Memiliki Akun Instagram.
                  </Typography>
                }
                control={
                  <Checkbox
                    checked={noInstagram}
                    onChange={handleNoInstagram}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                }
              />
            </Grid>
          </Grid>
          <InputTextField
            title={"Akun Youtube"}
            disabled={noYoutube}
            value={youtube || ""}
            handleEdit={(e) => setYoutube(e.target.value)}
            helperText={
              youtube?.length > 0 ? (
                ""
              ) : (
                <Typography component="span" sx={{ fontSize: "0.75rem" }} color="error">
                  *Wajib diisi Atau Di Pilih
                </Typography>
              )
            }
          />
          <Grid container justifyContent="center">
            <Grid
              container
              justifyContent="flex-start"
              sx={{ paddingLeft: "11%" }}
            >
              <FormControlLabel
                label={
                  <Typography color="black">
                    {" "}
                    Tidak Memiliki Akun Youtube.
                  </Typography>
                }
                control={
                  <Checkbox
                    checked={noYoutube}
                    onChange={handleNoYoutube}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                }
              />
            </Grid>
          </Grid>
          <InputTextField
            title={"Akun Twitter"}
            disabled={noTwitter}
            value={twitter || ""}
            handleEdit={(e) => setTwitter(e.target.value)}
            helperText={
              twitter?.length > 0 ? (
                ""
              ) : (
                <Typography component="span" sx={{ fontSize: "0.75rem" }} color="error">
                  *Wajib diisi Atau Di Pilih
                </Typography>
              )
            }
          />
          <Grid container justifyContent="center">
            <Grid
              container
              justifyContent="flex-start"
              sx={{ paddingLeft: "11%" }}
            >
              <FormControlLabel
                label={
                  <Typography color="black">
                    {" "}
                    Tidak Memiliki Akun Twitter.
                  </Typography>
                }
                control={
                  <Checkbox
                    checked={noTwitter}
                    onChange={handleNoTwitter}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                }
              />
            </Grid>
          </Grid>
          <InputTextField
            title={"Akun LinkedIn"}
            disabled={noLinkedin}
            value={linkedin || ""}
            handleEdit={(e) => setLinkedin(e.target.value)}
            helperText={
              linkedin?.length > 0 ? (
                ""
              ) : (
                <Typography component="span" sx={{ fontSize: "0.75rem" }} color="error">
                  *Wajib diisi Atau Di Pilih
                </Typography>
              )
            }
          />
          <Grid container justifyContent="center">
            <Grid
              container
              justifyContent="flex-start"
              sx={{ paddingLeft: "11%" }}
            >
              <FormControlLabel
                label={
                  <Typography color="black">
                    {" "}
                    Tidak Memiliki Akun LinkedIn.
                  </Typography>
                }
                control={
                  <Checkbox
                    checked={noLinkedin}
                    onChange={handleNoLinkedin}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                }
              />
            </Grid>
          </Grid>

          <FullGrid container justifyContent="flex-end" item xs={12}>
            <Button variant="contained" onClick={handleSave}>
              Save Data Pribadi
            </Button>
          </FullGrid>
        </SquareGrid>
        <FlexSquareGrid container justifyContent="center" item sm={12} md={3}>
          <Box sx={{ textAlign: "center", paddingTop: "1vh" }}>
            {dataPribadiID === -1 ? (
              <Typography color="error">
                Mohon untuk mengisi data pribadi terlebih dahulu
              </Typography>
            ) : (
              <Typography color="primary">File yang dilampirkan</Typography>
            )}
          </Box>
          {/* <ButtonFull
            disabled={dataPribadiID === -1}
            color={KTPFile > 0 ? "primary" : "error"}
            variant="outlined"
            onClick={() => {
              handleOpenFile("KTP", KTPFile > 0);
            }}
          >
            KTP
            <Typography sx={{ flexGrow: 1 }} />
            <ArrowForwardIosIcon />
          </ButtonFull>
          <ButtonFull
            disabled={dataPribadiID === -1}
            color={NPWPFile > 0 ? "primary" : "error"}
            variant="outlined"
            onClick={() => {
              handleOpenFile("NPWP", NPWPFile > 0);
            }}
          >
            NPWP
            <Typography sx={{ flexGrow: 1 }} />
            <ArrowForwardIosIcon />
          </ButtonFull> */}
          <ButtonFull
            disabled={dataPribadiID === -1}
            color={CVFile > 0 ? "primary" : "error"}
            variant="outlined"
            onClick={() => {
              handleOpenFile("CV", CVFile > 0);
            }}
          >
            CV
            <Typography sx={{ flexGrow: 1 }} />
            <ArrowForwardIosIcon />
          </ButtonFull>
          <ButtonFull
            disabled={dataPribadiID === -1}
            color={IjazahFile > 0 ? "primary" : "error"}
            variant="outlined"
            onClick={() => {
              handleOpenFile("Ijazah", IjazahFile > 0);
            }}
          >
            Ijazah
            <Typography sx={{ flexGrow: 1 }} />
            <ArrowForwardIosIcon />
          </ButtonFull>
          <ButtonFull
            disabled={dataPribadiID === -1}
            color={TranskripNilaiFile > 0 ? "primary" : "error"}
            variant="outlined"
            onClick={() => {
              handleOpenFile("TranskripNilai", TranskripNilaiFile > 0);
            }}
          >
            Transkrip Nilai
            <Typography sx={{ flexGrow: 1 }} />
            <ArrowForwardIosIcon />
          </ButtonFull>
          <ButtonFull
            disabled={dataPribadiID === -1}
            color={FotoFile > 0 ? "primary" : "error"}
            variant="outlined"
            onClick={() => {
              handleOpenFile("Foto", FotoFile > 0);
            }}
          >
            Foto Profile
            <Typography sx={{ flexGrow: 1 }} />
            <ArrowForwardIosIcon />
          </ButtonFull>
        </FlexSquareGrid>
      </Grid>
    </>
  );
}
